export class Constants {
  public static readonly dateFormatUI: string = 'DD.MM.yyyy';
  public static readonly dateFormatDB: string = 'yyyy-MM-DD';
  public static readonly dateTimeFormatUI: string = 'DD-MM-yyyy HH:mm:ss';
  static readonly riveSrc =
    'https://static.4play.com.tr/kgbcark.riv';
  public static readonly kgbAppLink: string = 'https://links.kimgbister.com/bireysel-landing-button';
}
